console.log("landing subscribe js loaded!")

function calcRewardsSavings(totalSaved, inputValue){
  
  var rewardsSaved = 0
  if(inputValue >= 11){
    totalSaved = totalSaved + 70
    rewardsSaved += 70
  } else if(inputValue >= 6){
    totalSaved = totalSaved + 20
    rewardsSaved += 20
  }
  console.log("totalSaved before 4 ", totalSaved)
  if(inputValue >= 4){
    
    console.log("greater than 4")
    console.log("rs at this point")
    console.log(totalSaved, rewardsSaved)
    var inputValueCopy = inputValue
    if(inputValueCopy % 4 > 0){
      inputValueCopy = inputValueCopy - (inputValueCopy % 4)
    }
    console.log(inputValueCopy)
    console.log(((inputValueCopy / 4) * 10))
     totalSaved = totalSaved + ((inputValueCopy / 4) * 10)
    rewardsSaved += ((inputValueCopy / 4) * 10)
  }
  console.log("TS HERE ", totalSaved)
  return [totalSaved, rewardsSaved]
}

function calcSavings(){
    var inputValue = document.querySelector('#months-value').value
      var rewardsSpan = document.querySelector('.rewards-savings-span')
      var monthlySpan = document.querySelector('.monthly-rewards-savings-span')
      var justRewardsSpan = document.querySelector('.just-rewards-savings-span')

      console.log('i been clickedd')
      console.log(inputValue)

      // format as currency
      var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    
      // These options are needed to round to whole numbers if that's what you want.
      // minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

  // savings
  // Monthly Subscription: $18 per month
  // Rewards: $10 every 4 months
  // Taking all rewards actions: $5 total
  // VIP Tier Rewards: 20 for 6 months, 70 for 11 months

  var totalSaved = (inputValue * 18)
  var monthlySaved = (inputValue * 18)
  var rewardsSaved = 0
  // account for different month totals
  console.log("incoming calcRewards func")
  console.log("IT ME ",calcRewardsSavings(totalSaved, inputValue))
  console.log("IT ME AGAIN ",calcRewardsSavings(totalSaved, inputValue)[0])
  
  var finalTotalSaved = calcRewardsSavings(totalSaved, inputValue)[0]
  var finalRewardsSaved = calcRewardsSavings(totalSaved, inputValue)[1]
console.log("ts, rs")
  console.log(finalTotalSaved, finalRewardsSaved)

      rewardsSpan.innerHTML = formatter.format(finalTotalSaved)
      monthlySpan.innerHTML = formatter.format(monthlySaved)
      justRewardsSpan.innerHTML = formatter.format(finalRewardsSaved)


  var newDropdown = document.querySelector("#months-value")
  console.log("incoming value")
  console.log(newDropdown.value)
}
function setButtonListener(){
      var rewardsInput = document.querySelector('#months-value')
      rewardsInput.addEventListener("change", calcSavings)
  calcSavings()
} 

// wait for rewards button to appear so we can attach event listener
function waitForElement(id, callback){
    var loops = setInterval(function(){
        if(document.querySelector(id)){
            clearInterval(loops);
            callback();
        }
    }, 100);
}

waitForElement("#months-value",setButtonListener);

